import { chat } from "../../libs/roomnew";
import { v4 as uuidv4 } from 'uuid';

export default class Attachment {
    constructor(file,isInline = false) {
        this.id = uuidv4();
        this.file = file;
        this.url = URL.createObjectURL(file);
        this.name = file.name;
        this.size = file.size;
        this.type = file.type;
        this.isInline = isInline;
        this.onUpload = null;
        this.uploaded = null;
    }

    async getSrc() {
        const src = await new Promise((resolve, reject) => {
            const reader = new FileReader();
            reader.readAsDataURL(this.file);
            reader.onload = () => resolve(reader.result);
            reader.onerror = (error) => reject(error);
          });
        this.src = src;
        return this.src
    }

    isImage() {
        const imageTypeRegex = /image\/(png|jpg|jpeg|gif|bmp|webp|svg\+xml|tiff)/;
        return imageTypeRegex.test(this.type)
    }

    isVideo() {
        const videoTypeRegex = /video\/(mp4|webm|ogg)/;
        return videoTypeRegex.test(this.type)
    }

    async startUpload() {
        if(chat.provider){
            return chat.provider.uploadAttachment(this).then((uploadedAttachment) => {
                this.uploaded = uploadedAttachment;
                this.onUpload && this.onUpload(this);
            }).catch((error) => {
                console.error('Error uploading attachment', error);
            })
        }
        // Native Kino chat uploads files as multipart at send time; just mark ready.
        this.uploaded = true;
        this.onUpload && this.onUpload(this);
    }
}
